const module = { name: 'mobile/global/sw-install', exports: {} }; const exports = module.exports;



import { Fandango_debugLog as debugLog } from 'require-core';



const SERVICE_WORKER_FILE = '/sw-mweb.js'


const SERVICE_WORKER_OPTIONS = {
    scope: '/'
}
function newWorker(registration, cb) {
    if (registration.waiting) {
        return cb();
    }
    function listenInstalledStateChange() {
        registration.installing.addEventListener('statechange', (event) => {
            if (event.target.state === 'installed') {
                return cb();
            }
        });
    }
    if (registration.installing) {
        return listenInstalledStateChange();
    }
    registration.addEventListener('updatefound', listenInstalledStateChange);
}
function onFail(err) {
    debugLog.log(module.name, 'registration failed', err);
}
function onSuccess(registration) {
    if (!navigator.serviceWorker.controller) {
        return debugLog.log(module.name, 'registration successful. scope: ', registration.scope);
    }
    newWorker(registration, () => registration.waiting.postMessage('skipWaiting'));
}
function init() {
    navigator.serviceWorker.register(SERVICE_WORKER_FILE, SERVICE_WORKER_OPTIONS)
        .then(onSuccess)
        .catch(onFail);
}
module.exports = {
    init
};
export default module.exports;